import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../ParticipantsStore';
import ModalStore from '../../../../../Modal/Store';
import ReclaimLicensesStore from '../Store';
import ReadyBody from './ReadyBody';
import SucceededBody from './SucceededBody';
import Loader from '../../../../../Loader';
import FlashMessage from '../../../../../FlashMessage';
import { emptyFragment } from '../../../../../../EmptyFragment';

interface Props {
  participantsStore: ParticipantsStore;
  reclaimLicensesStore: ReclaimLicensesStore;
  modalStore: ModalStore;
}

function FormState({ participantsStore, reclaimLicensesStore, modalStore }: Props) {
  const { state } = reclaimLicensesStore;
  switch (state.kind) {
    case 'ready':
    case 'error':
      return (
        <>
          {reclaimLicensesStore.notification
            .map((alert) => <FlashMessage alert={alert} />)
            .getOrElse(emptyFragment)}
          <ReadyBody
            participantsStore={participantsStore}
            modalStore={modalStore}
            reclaimLicensesStore={reclaimLicensesStore}
          />
        </>
      );
    case 'succeeded':
      return <SucceededBody modalStore={modalStore} state={state} store={reclaimLicensesStore} />;
    case 'updating':
      return <Loader className="h-full py-40" />;
  }
}

export default observer(FormState);
